export default "/images/vendor/flag-icon-css/flags/4x3/ee.svg?887a78f0eb107b3ce616a7fdf0feab97";